import Main from '@/views/administracion/configuracion/catalogos/subtiposobra/Main.vue';
import Default from '@/views/administracion/configuracion/catalogos/subtiposobra/Default.vue';

const auth = ['Catálogos:ver'];
const scopes = ['Catálogos:crear', 'Catálogos:editar', 'Catálogos:eliminar'];

const subTiposObras = [
  {
    path: 'sub-tipos-obra',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'catalogoSubTiposObra',
        path: '/',
        meta: {
          title: 'Sub Tipos de Obra',
          auth,
          scopes,
        },
        component: Default,
      },
    ],
  },
];

export default subTiposObras;
